<template>
  <div v-if="bannerMsg" class="row banner-container" :style="[bannerStyle]">
    <div class="col-sm-12 d-flex justify-content-center align-items-center banner-wrapper" :class="callerComp === 'exc-revamp' ? 'pt-2 pb-2' : ''" :style="{textAlign: bannerStyle.textAlign ? bannerStyle.textAlign : 'center'}">
      <p v-if="bannerMsg.toLowerCase() && !bannerMsg.toLowerCase().includes('click here')" v-html="bannerMsg"></p>
      <p v-else>
        <span v-for="(text, index) in bannerTxtArr" :key="index">
          <a v-if="text.toLowerCase() === 'click here'" @click="triggerEvent" :href="$parent.$parent && $parent.$parent.isDesktop ? 'https://play.google.com/store/apps/details?id=com.thesouledstore' : 'https://bit.ly/appxtss'" class="unl color-inherit">{{text}}</a>
          <span v-else>{{text}}</span>
        </span>
      </p>
      <img v-if="toggleCashbackPopup" class="i-image pointer know-more-icon" @click="toggleCashbackPopup(true)"
        src="https://prod-img.thesouledstore.com/static/icons/tssHelpDetails.png"
      >
    </div>
  </div>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $

  export default {
    name: 'BannerPlaceHolderMsg',
    data () {
      return {}
    },
    props: ['bannerStyle', 'bannerMsg', 'callerComp', 'toggleCashbackPopup'],
    computed: {
      bannerTxtArr () {
        if (this.bannerMsg) {
          const msg = this.bannerMsg.toLowerCase()
          const msgIndex = msg && msg.indexOf('click here')
          const clickHereLen = 'click here'.length
          return [this.bannerMsg.slice(0, msgIndex), this.bannerMsg.slice(msgIndex, msgIndex + clickHereLen), this.bannerMsg.slice(msgIndex + clickHereLen)]
        }
      }
    },
    mounted () {
    },
    methods: {
      triggerEvent () {
        this.$store.commit('GTAG_EVENT', {eventName: 'App_Banner_Cashback_Click', payload: {}})
      }
    },
    created () {
    },
    beforeDestroy () {
    }
  }
</script>

<style lang="css" scoped>
.banner-container {
  padding: 5px 10px;
  font-size: 17px;
}
.banner-wrapper {
  gap: 5px;
}
.banner-container p {
  margin-bottom: unset;
}
.banner-container .know-more-icon {
  height: 18px;
  width: 18px;
}
@media screen and (max-width: 768px) {
  .banner-container {
    font-size: 11px;
  }
  .banner-container .know-more-icon {
    height: 12px;
    width: 12px;
    margin-top: -2px;
  }
}
</style>



// WEBPACK FOOTER //
// BannerPlaceHolderMsg.vue?724a1c98